const invite = () =>
  import(/* webpackChunkName: "invite" */ '../../pages/subAccount/invite')
const review = () =>
  import(/* webpackChunkName: "invite" */ '../../pages/subAccount/review')
const beInvited = () =>
  import(/* webpackChunkName: "invite" */ '../../pages/subAccount/beInvited')

export default [
  {
    path: '/subAccount/invite',
    meta: { title: '邀请管理员' },
    component: invite
  },
  {
    path: '/subAccount/review',
    name: 'Review',
    meta: { title: '待审核' },
    component: review
  },
  {
    path: '/subAccount/beInvited',
    name: 'beInvited',
    meta: { title: '接受邀请' },
    component: beInvited
  }
  // {
  //   path: '/invite/codeItem',
  //   meta: { title: '邀请码' },
  //   component: InviteCodeList
  // },
  // {
  //   path: '/exchange/record',
  //   meta: { title: '兑换记录' },
  //   component: ExchangeList
  // }
]
